var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAndResidents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 72,
    viewBox: "0 0 80 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 52.2001C28.4 50.0001 22.5 48.9001 18.9 48.9001C12.8 48.9001 0.5 52.0001 0.5 58.1001V64.7001H16.2V63.3001C16.2 57.3001 24.8 53.7001 32.5 52.2001Z",
    fill: "#82AA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1 52.2001C51.2 50.0001 57.1 48.9001 60.7 48.9001C66.8 48.9001 79.1 52.0001 79.1 58.1001V64.7001H63.4V63.3001C63.4 57.3001 54.8 53.7001 47.1 52.2001Z",
    fill: "#82AA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7 43.6C65.1 43.6 68.5 40.1 68.5 35.7001C68.5 31.3001 65 27.8 60.7 27.8C56.4 27.8 52.8 31.3001 52.8 35.7001C52.8 40.1 56.4 43.6 60.7 43.6Z",
    fill: "#82AA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8 51.1C44.2 51.1 47.6 47.6 47.6 43.2001C47.6 38.8001 44.1 35.3 39.8 35.3C35.5 35.3 31.9 38.8001 31.9 43.2001C31.9 47.6 35.4 51.1 39.8 51.1Z",
    fill: "#82AA00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8 56.3C33.7 56.3 21.4 59.4 21.4 65.5V72H58.1V65.4001C58.1 59.4001 45.9 56.3 39.8 56.3Z",
    fill: "#82AA00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7 35.7001C26.7 31.3001 23.2 27.8 18.8 27.8C14.4 27.8 11 31.4001 11 35.7001C11 40.0001 14.5 43.6 18.8 43.6C23.1 43.6 26.7 40.1 26.7 35.7001Z",
    fill: "#82AA00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6 13.6C43.2 13.6 46 10.7 46 7.20005C46 3.70005 43.1 0.800049 39.6 0.800049C36 0.800049 33.2 3.70005 33.2 7.20005C33.2 10.7 36.1 13.6 39.6 13.6Z",
    fill: "#989898"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6 15.5C35.7 15.5 27.8 17.5 27.8 21.4V25.6H51.4V21.4C51.4 17.5 43.6 15.5 39.6 15.5Z",
    fill: "#989898"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAndResidents);
export default __webpack_public_path__ + "static/media/user_and_residents.1242a803e6dabc25f0c6296ed9f9f068.svg";
export { ForwardRef as ReactComponent };